import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { ReporteriaService } from '../../../../core/services/http/reporteria/reporteria.service';
export class HeaderComponent {
    constructor(authService, reporteriaService) {
        this.authService = authService;
        this.reporteriaService = reporteriaService;
        this.authService.idleUser();
    }
    ngOnInit() {
        this.getDataClient();
    }
    exit(e) {
        this.moduloSeleccionado();
        this.reporteUsabilidad('Cerrar sesión', 'Cierre de sesión de usuario', true);
        e.preventDefault();
        this.authService.logout();
    }
    getDataClient() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rutCliente = localStorage.getItem('cbRutCliente');
            const response = yield this.authService.leerCliente(rutCliente);
            if (response['status']) {
                this.sexoCliente = response['data']['datosCliente']['sexo'];
                this.sexoCliente = this.sexoCliente === 'M' ? 'Bienvenido' : 'Bienvenida';
            }
            this.nombreCliente = localStorage.getItem('cbNombre');
        });
    }
    moduloSeleccionado() {
        if (this.modulo === 'venta-bonos') {
            this.modulo = 'Compra de bonos';
        }
        if (this.modulo === 'reembolso') {
            this.modulo = 'Reembolso';
        }
        if (this.modulo === 'cotizaciones') {
            this.modulo = 'Pago de cotizaciones';
        }
        if (this.modulo === 'certificados') {
            this.modulo = 'Certificados';
        }
        if (this.modulo === 'devolucion') {
            this.modulo = 'Devolución de excesos';
        }
        if (this.modulo === 'pagobonos') {
            this.modulo = 'Pago de bonos emitidos';
        }
        if (this.modulo === 'licencias') {
            this.modulo = 'Licencias';
        }
        if (this.modulo === 'menu') {
            this.modulo = 'Menú';
        }
    }
    reporteUsabilidad(recurso, respuesta, status) {
        const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');
        this.reporteriaService.saveLog(this.modulo, recurso, respuesta, 'Front-End', status, rut);
    }
}
